// extracted by mini-css-extract-plugin
export default {"feed":"NewsFeedCommon_feed__0vFjE","feed__cards":"NewsFeedCommon_feed__cards__hnrBa"};